import {
  GetProductTreeRequest,
  GetProductTreeResponse,
  GetProductTreesResponse,
} from "@financial-advisory/data-access/api-types";
import { productRecommendationApi } from "./productRecommendationApi";

const productTreesApi = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductTrees: builder.query<GetProductTreesResponse, null>({
      query: () => ({
        url: `product-trees`,
        method: "GET",
      }),
    }),
    getProductTree: builder.query<
      GetProductTreeResponse,
      GetProductTreeRequest
    >({
      query: ({ treeId }) => ({
        url: `product-trees/${treeId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetProductTreesQuery,
  useLazyGetProductTreeQuery,
  useGetProductTreeQuery,
  useLazyGetProductTreesQuery,
} = productTreesApi;
